<script setup lang="ts">
import { ref } from 'vue';

import { authRequest } from '../api.ts';
import { useAuthenticationAction } from '../authenticationAction.ts';
import AuthEmailSent from './AuthEmailSent.vue';

defineProps<{ showBack: boolean }>();
const emit = defineEmits<{ back: [] }>();
const email = ref('');
const emailSent = ref(false);
const { busy, run } = useAuthenticationAction();

function recoverPassword() {
    void run(async () => {
        await authRequest('links', 'POST', {
            email: email.value,
            mode: 'login',
            purpose: 'login',
            intended: '/settings/account?action=change-password',
        });
        emailSent.value = true;
    });
}
</script>

<template>
    <form v-if="!emailSent" class="stack gap-lg" @submit.prevent="recoverPassword">
        <div class="stack align-center gap-md text-center">
            <h2>Reset Your Password</h2>
            <p class="color-muted text-sm">
                Enter your email and we’ll send you a secure sign-in link. After signing in, you can
                set a new password.
            </p>
        </div>

        <div class="stack gap-xs">
            <label for="auth-reset-email" class="field-label">Email</label>
            <input
                id="auth-reset-email"
                v-model="email"
                class="input text-lg"
                type="email"
                autocomplete="email"
                maxlength="255"
                :disabled="busy"
                required
            />
        </div>

        <button
            class="btn btn--lg bg-primary full-width"
            :class="{ 'is-loading': busy }"
            :disabled="busy"
        >
            Email Me a Sign-In Link
        </button>

        <button
            v-if="showBack"
            type="button"
            class="btn btn--transparent color-primary full-width"
            :disabled="busy"
            @click="emit('back')"
        >
            Back to Sign In
        </button>
    </form>

    <AuthEmailSent
        v-else
        :email="email"
        detail="for a secure sign-in link. After signing in, you can set a new password."
        @back="emailSent = false"
    />
</template>
